import CreateFormativeAssessmentView from "@features/tools/view/formative-assessment-view/create-formative-assessment-view";

const CreateFormativeAssessment = () => {
  return <CreateFormativeAssessmentView />;
};

export default CreateFormativeAssessment;
